<img alt="radar"
     height="{{height}}" ngSrc="radar.png" style="overflow: visible" width="{{width}}">